module.exports = __webpack_public_path__ + "img/cv-empty-icon.807ff857.svg";